<div class="accordion">
  <div class="accordion-header" (click)="toggleExpanded()" (keydown.enter)="toggleExpanded()"
  (keydown.space)="toggleExpanded()" tabindex="0">
    <div class="header-wrapper">
      <ng-container *ngIf="headerTemplate; else defaultHeader">
        <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
      </ng-container>
      
      <ng-template #defaultHeader>
        <div class="default-header">
          <hyperkit-typography class="header-title" variant="label1" align="left" color="primary">{{title}}</hyperkit-typography>
          <div class="header-actions">
              <hyperkit-tag
              *ngIf="badgeText && badgeText.length > 0"
              class="header-badge"
              [mode]="'outline'"
              [closable]="false"
              [text]="badgeText">
            </hyperkit-tag>
          </div>
        </div>
      </ng-template>  
      <div class="icon-container">
        <hyperkit-icon class="arrow-icon" [ngClass]="{'expanded': expanded}" icon="chevron-down" size="base"></hyperkit-icon>
      </div>
    </div>
  </div>
  
  <div class="accordion-content" [@expandCollapse]="expanded ? 'expanded' : 'collapsed'">
    <ng-content></ng-content>
  </div>
</div>